import { useState } from "react"

// ** Components
import Box from "../Box"

// ** Icons
import { ChevronDownIcon } from "@heroicons/react/24/outline"

// ** Utils
import { classNames } from "../../utils/helpers"
import Heading from "../Heading"
import Text from "../Text"
import { PortableText } from "@portabletext/react"
import { serializers } from "../Serializers"

interface NewAccordionProps {
  data: any
  multiple?: boolean
  tags?: [string]
}
const NewAccordion = (props: NewAccordionProps) => {
  const { data, multiple, tags } = props
  const [active, setActive] = useState(null)

  return (
    <>
      {data.map((tab: any, idx: any) => (
        <AccordionItem
          tags={tags}
          key={idx}
          {...tab}
          active={active === idx}
          multiple={multiple}
          onToggle={() => setActive((a) => (a === idx ? "" : idx))}
        />
      ))}
    </>
  )
}

interface AccordionItemProps {
  title: string
  content: string
  active: boolean
  multiple?: boolean
  onToggle: () => void
  _rawContent?: any
  tags?: [string]
}
const AccordionItem = (props: AccordionItemProps) => {
  const { title, content, active, multiple, onToggle, _rawContent, tags } =
    props
  const [visibility, setVisibility] = useState(false)

  const isActive = () => (multiple ? visibility : active)

  const toggleVisibility = () => {
    setVisibility((v) => !v)
    onToggle()
  }

  return (
    <Box as="div" className="py-6">
      <dt className="text-lg">
        <button
          onClick={toggleVisibility}
          className="flex w-full items-start justify-between"
        >
          {tags?.includes("title-big-font") ? (
            <Heading
              as="h4"
              component="span"
              className="text-blue-500 text-left"
            >
              {title}
            </Heading>
          ) : (
            <Heading
              as="h6"
              component="span"
              className="text-blue-500 text-left !text-lg"
            >
              {title}
            </Heading>
          )}
          <span className="ml-6 flex h-7 items-center">
            <ChevronDownIcon
              className={classNames(
                isActive() ? "-rotate-180" : "rotate-0",
                "h-6 w-6 transform"
              )}
              aria-hidden="true"
            />
          </span>
        </button>
      </dt>
      {isActive() && (
        <Box as="dd" className="mt-2 pr-4">
          {content ? (
            <Text variant="body-copy">
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </Text>
          ) : _rawContent ? (
            <PortableText components={serializers} value={_rawContent} />
          ) : null}
        </Box>
      )}
    </Box>
  )
}

export default NewAccordion
